import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';
import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

const propertyTypeLabels = {
    farms_land: 'Farms/land',
    flats: 'Flats',
    houses: 'Houses'
};

export type PropertyType = typeof propertyTypes[number];

type SelectNewHomesDevelopersPropertyTypeProps = {
    value: PropertyType;
    onChange: (propertyType: PropertyType) => void;
};

export const SelectNewHomesDevelopersPropertyType = ({
    value,
    onChange
}: SelectNewHomesDevelopersPropertyTypeProps) => {
    return (
        <MultiColumnDropdownWithLabel
            title={
                value === 'property' ? 'Show all' : propertyTypeLabels[value]
            }
            label="Property type"
            testId="PropertyType_testId"
            isLeft
            minWidthOverride="100%"
        >
            <RadioGroup
                label=""
                value={value}
                items={[
                    {
                        id: 'show_all',
                        value: 'property',
                        label: 'Show all'
                    },
                    {
                        id: 'houses',
                        value: 'houses',
                        label: 'Houses'
                    },
                    {
                        id: 'flats',
                        value: 'flats',
                        label: 'Flats'
                    }
                ]}
                onValueChange={onChange}
            />
        </MultiColumnDropdownWithLabel>
    );
};
